import React from "react";
import { Localization } from "@viamap/viamap2-common";
import { ADModalBody, ADModalFooter, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassButton, GlassButtonRow } from "src/components/GlassButtons";

const hints = ["attributes", "operators", "functions", "relations", "selectors", "cubes", "compatibility"];
const examples = ["arithmetic", "conditional", "round", "first value", "has value", "traversal", "deep traversal", "parent lookup", "dynamic attribute", "filtered traversal", "quoted names", "aggregate arguments", "parent aggregate", "filtered count", "parent fallback", "navigation", "cube slice", "cube summary", "cube selector", "cube total", "child cubes", "cube all dimensions"];

export function PLAExpressionHelpDialog(props: { onClose: () => void }) {
   return (
      <AdvancedDragModal title={Localization.getText("Expression syntax help")} PosDefault={{ width: "760px", left: "50%", transform: "translateX(-50%)", top: "120px" }} onClose={props.onClose}>
         <ADModalBody>
            <ul>
               {hints.map((hint) => <li key={hint}>{Localization.getText(`Expression syntax hint ${hint}`)}</li>)}
               <li>
                  <strong>{Localization.getText("Examples")}</strong>
                  <ul>{examples.map((example) => <li key={example}>{Localization.getText(`Expression syntax example ${example}`)}</li>)}</ul>
               </li>
            </ul>
         </ADModalBody>
         <ADModalFooter>
            <GlassButtonRow adjust="end">
               <GlassButton onClick={props.onClose}>{Localization.getText("Close")}</GlassButton>
            </GlassButtonRow>
         </ADModalFooter>
      </AdvancedDragModal>
   );
}
